import { createLogic } from 'redux-logic'
import { SYNC_PROGRAM_OPTIONS } from '@app/constants/programOptions'
import { deps } from '@app/constants/channels'
import { setInitialOptions } from '@app/actions/programOptions'
import { programOptionsNumbers } from '@app/lib/ProgramOptions/index'
import programOptionChannel from '@app/api/programOptions'
import { API_REQUEST_CANCEL } from '@app/constants/apiRequest'
import { apiRequestSent, apiRequestDone, apiRequestFailed } from '@app/actions/apiRequest'

const fetchProgramOptionsLogic = createLogic({
  type: SYNC_PROGRAM_OPTIONS,
  cancelType: API_REQUEST_CANCEL,

  process(_, dispatch, done) {
    programOptionChannel({
      request: (channel) => {
        channel.perform('get_program_options', { numbers: programOptionsNumbers, ...deps })
        dispatch(apiRequestSent(SYNC_PROGRAM_OPTIONS))
      },
      response: (data, isFinished) => {
        const { programOptions, error } = data
        if (error && error.msg) {
          dispatch(apiRequestFailed(error.msg, error.code))
        } else {
          const stringifyProgramOption = programOptions.map((option) => ({ ...option, value: option.value.toString() }))
          dispatch(setInitialOptions(stringifyProgramOption))
          if (isFinished) {
            dispatch(apiRequestDone(SYNC_PROGRAM_OPTIONS))
          }
        }
        if (isFinished) {
          done()
        }
      },
    })
  },
})

export default fetchProgramOptionsLogic
